import { abyssColors } from '@/theme/colors';
import { Box, styled as muiStyled } from '@mui/material';

export const tabStyles = {
  width: '100%',
  marginTop: '0.8rem',
  minHeight: 'fit-content',
  paddingLeft: '2rem',
  paddingRight: '2rem',
  '& .MuiTabs-flexContainer': {
    gap: '2.4rem',
  },
  '& .MuiTab-root': {
    width: 'fit-content',
    padding: '1.2rem 1.2rem',
    // paddingTop: '2.4rem',
    fontSize: '1.6rem',
    fontStyle: 'normal',
    fontWeight: 400,
    flex: 1,
    minHeight: 'fit-content',
    textTransform: 'none',
    lineHeight: '1.6rem',
    color: `${abyssColors.primary[500]} !important`,
  },
  '& .MuiTab-root.Mui-selected': {
    color: `${abyssColors.primary[500]} !important`,
    fontWeight: 700,
  },
  '& .MuiTab-textColorPrimary': {
    color: abyssColors.primary[400],
  },
  '& .MuiTabs-indicator': {
    backgroundColor: abyssColors.primary[500],
    height: '0.4rem',
    borderRadius: '0.4rem',
    zIndex: 2,
  },
};

export const FloatingLine = muiStyled(Box)(() => ({
  borderTop: `0.1rem solid ${abyssColors.primary[200]}`,
  width: '100%',
  position: 'relative',
  bottom: '0.3rem',
  zIndex: '1',
  opacity: 0.5,
}));

export const accordionStyles = {
  border: 0,
  padding: '0 2.4rem',
  '& .MuiAccordionSummary-root': {
    padding: 0,
    minHeight: 'fit-content',
  },
  '& .MuiAccordionSummary-content': {
    margin: '2.4rem 0',
  },
  '& .MuiAccordionSummary-expandIconWrapper': {
    marginRight: '1.2rem',
  },
  '& .MuiSvgIcon-root': {
    color: abyssColors.primary[500],
    fontSize: '2rem',
    margin: 0,
  },
};

export const summaryStyles = {
  color: abyssColors.primary[700],
  fontSize: '1.6rem',
  fontWeight: 500,
  lineHeight: '2.4rem',
};
